﻿import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BaseService } from '../../lib-shared/services/base.service';
import { catchError } from 'rxjs/operators';
import { ResponseResult } from '../../lib-shared/models/response-result';


@Injectable({ providedIn: 'root' })
export class WardsService extends BaseService {

    constructor(http: HttpClient, injector: Injector) {
        super(http, injector, `${environment.apiDomain.dapFoodEndPoint}/Wards`);
    }

    Save(item: any): Promise<ResponseResult> {
        return this._http
            .post<ResponseResult>(this.serviceUri, item)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }

    Gets(key: string, idWard: number, idDistrict: number, offset?: number, limit?: number, sortField?: string, isAsc: boolean = false) {
        const queryString = `${this.serviceUri}?key=${key}&idWard=${idWard}&idDistrict=${idDistrict}&offset=${offset}&limit=${limit}&sortField=${sortField}&isAsc=${isAsc}`;
        return this.defaultGet(queryString);
    }

    GetShort(idDistrict: number) {
        const queryString = `${this.serviceUri}/GetShort?idDistrict=${idDistrict}`;
        return this.defaultGet(queryString);
    }

    GetShortByListId(lstId: string) {
        const queryString = `${this.serviceUri}/GetShortByListId?listId=${lstId}`;
        return this.defaultGet(queryString);
    }

    ChangeDeleted(item: any): Promise<ResponseResult> {
        return this._http
            .post<ResponseResult>(this.serviceUri + '/ChangeDeleted/' + item.id, item)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }
}

